import type { RenDecorationMarketTemplate, RenDecorationSchema } from '../../types'

export function normalizeUpperText(value: unknown): string {
  return String(value ?? '')
    .trim()
    .toUpperCase()
}

export function normalizeSearch(value: unknown): string {
  return String(value ?? '')
    .trim()
    .toLowerCase()
}

export function uniqueSorted(values: string[]): string[] {
  return Array.from(new Set(values)).sort((a, b) => a.localeCompare(b))
}

export function templateEnabled(template: RenDecorationMarketTemplate): boolean {
  const status = normalizeUpperText(template.status)
  return !['DISABLED', 'DELETED', 'RECYCLED', 'OFFLINE'].includes(status)
}

export function isRecycledTemplate(template: RenDecorationMarketTemplate): boolean {
  return normalizeUpperText(template.status) === 'RECYCLED'
}

export function templateStatusLabel(template: RenDecorationMarketTemplate): string {
  const labels: Record<string, string> = {
    LISTED: '已上架',
    ACTIVE: '已启用',
    DISABLED: '已停用',
    RECYCLED: '回收站',
  }
  const status = normalizeUpperText(template.status)
  return labels[status] ?? (status || '未知状态')
}

export function templateScopeLabel(template: RenDecorationMarketTemplate): string {
  return template.publicTemplate ? '系统模板' : '租户模板'
}

export function templateTypeLabel(type: string): string {
  const labels: Record<string, string> = {
    SYSTEM: '系统',
    TENANT: '租户',
    PAGE: '页面',
    HOME: '首页',
    MARKETING: '营销',
    INDUSTRY: '行业',
  }
  const normalized = normalizeUpperText(type)
  return labels[normalized] ?? (normalized || '未分类')
}

export function pageTypeLabel(type: string): string {
  const labels: Record<string, string> = {
    HOME: '首页',
    SHOP_HOME: '店铺首页',
    DETAIL: '详情页',
    ACTIVITY: '活动页',
    PROFILE: '个人中心',
    APP_PAGE: '应用页',
    LIST: '列表页',
  }
  const normalized = normalizeUpperText(type)
  return labels[normalized] ?? (normalized || '页面')
}

export function formatTemplateDate(value?: string): string {
  if (!value) return '-'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return value
  if (date.getFullYear() <= 1970) return '系统内置'
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
}

export function parseTemplateSchema(raw?: string): RenDecorationSchema | null {
  try {
    const parsed = JSON.parse(raw || '{}') as RenDecorationSchema
    return parsed?.page && Array.isArray(parsed.components) ? parsed : null
  } catch {
    return null
  }
}
